// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","header":"header-3jH8h","title__wrapper":"title__wrapper-3ztY5","title":"title-B8_zw"};